module.exports = __webpack_public_path__ + "img/desc_bottom_bl2fl01.2f4b0393.png";